<template>
    <fieldset class="form" :disabled="isDisabled">
        <h5>Card details</h5>

        <ValidationObserver class="row" ref="form">
            <div class="col-sm-12">
                <label class="form-label">Full Name:*</label>
                <div class="row">
                    <ValidationProvider class="col-sm-6 mb-3" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <input id="first_name" placeholder="First Name" type="text" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="credit_card.card_first_name">
                        </div>

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-sm-6 mb-3" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <input id="last_name" placeholder="Last Name" type="text" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="credit_card.card_last_name">
                        </div>

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
            </div>

            <ValidationProvider class="col-md-12 mb-3" name="Card Number" rules="required|credit_card" v-slot="{ errors }">
                <label class="form-label">Card Number*</label>
                <div class="form-group mb-0">
                    <input
                        type="text"
                        :class="['form-control mb-1', {'input-error' : errors[0] }]"
                        v-mask="['####-####-####-####']"
                        v-model="credit_card.card_number"
                    >
                </div>

                <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                    {{ errors[0] }}
                </div>
            </ValidationProvider>

            <div class="col-md-6">
                <label class="form-label">Expiration</label>
                <div class="row">
                    <ValidationProvider class="col-6 mb-3" name="Card Expiration Month" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <select :class="['custom-select mb-1', {'input-error' : errors[0] }]" v-model="credit_card.card_expiration_month">
                                <option :value="null" disabled>MM</option>
                                <option
                                    v-for="month in 12"
                                    :key="month"
                                    :value="month.toString()"
                                >
                                    {{ month < 10 ? '0' + month : month }}
                                </option>
                            </select>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-6 mb-3" name="Card Expiration Year" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <select :class="['custom-select mb-1', {'input-error' : errors[0] }]" v-model="credit_card.card_expiration_year">
                                <option :value="null" disabled>YYYY</option>
                                <option
                                    v-for="(year, index) in 21"
                                    :key="year"
                                    :value="(index + currentYear).toString()"
                                >
                                    {{ index + currentYear }}
                                </option>
                            </select>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
            </div>

            <ValidationProvider class="col-md-3 mb-3" name="Card CVV" rules="required|cvv" v-slot="{ errors }">
                <label class="form-label">CVV</label>
                <div class="form-group mb-0">
                    <input
                        type="password"
                        :class="['form-control mb-1', {'input-error' : errors[0] }]"
                        v-mask="['###', '####']"
                        v-model="credit_card.card_cvv"
                    >

                    <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                        {{ errors[0] }}
                    </div>
                </div>
            </ValidationProvider>
        </ValidationObserver>
    </fieldset>
</template>

<script>
    import resetAnimation from "@/js/mixins/reset-animation";

    export default {
        name: "PaymentCard",
        mixins:  [ resetAnimation ],
        props: {
            isDisabled: {
                type: Boolean,
                required: true
            },
            order: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                credit_card: {
                    card_first_name: null,
                    card_last_name: null,
                    card_number: null,
                    card_expiration_month: null,
                    card_expiration_year: null,
                    card_cvv: null,
                },
            }
        },
        mounted() {
            this.resetForm();
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            },
        },
        methods: {
            resetForm() {
                this.credit_card = {
                    card_first_name: this.order ? this.order.first_name : null,
                    card_last_name: this.order ? this.order.last_name : null,
                    card_number: null,
                    card_expiration_month: null,
                    card_expiration_year: null,
                    card_cvv: null,
                }
            },
        }
    }
</script>

<style scoped>
    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    .input-error {
        border: 2px solid #ffb996 !important;
        background-color: #fff8f6 !important;
        border-radius: 3px !important;
    }
</style>
